//ointerfaces
import { ICaretButton } from "@/interfaces/buttons";

//Icon
import Icon from "@/components/elements/icons/Icons";
import { IconLibrary } from "@/interfaces/IconLibrary";

//styling
import "../../../../css/global/buttons/CaretButton.scss";



const CaretButton = ({ content, isDisabled = false, ariaLabel, onButtonClick, isLink, linkUrl}: ICaretButton) => {

    if (isLink) {
        return (
            <a
                className={`caret-button ${isDisabled && "disabled-style-link"}`}
                aria-label={ariaLabel}
                href={linkUrl}
            >
                {content}
                <Icon iconName={IconLibrary.CHEVRON_DOWN} color="var(--thriveCharcoal)" sizeInPx="6"/>
            </a>
        )
    } else {
        return (
            <button
                role="button"
                className={`caret-button`}
                disabled={isDisabled}
                aria-label={ariaLabel}
                onClick={(e) => {
                    e.preventDefault();
                    onButtonClick?.();
                }}
            >
                {content}
                <Icon iconName={IconLibrary.CHEVRON_DOWN} color="var(--thriveCharcoal)" sizeInPx="6"/>
            </button>
        );
    }
};

export default CaretButton